import './styles/tokens.css';
import './styles/base.css';
import './styles/screens.css';

import { Router } from './router/router';
import { createListingScreen } from './screens/listing';
import { createProductDetailScreen } from './screens/product-detail';
import { createCustomizeScreen } from './screens/customize';
import { createCheckoutScreen } from './screens/checkout';

async function bootstrap(): Promise<void> {
  const root = document.getElementById('app');
  if (!root) {
    throw new Error('Missing #app root element');
  }

  const router = new Router(root);
  router.register(createListingScreen());
  router.register(createProductDetailScreen());
  router.register(createCustomizeScreen());
  router.register(createCheckoutScreen());

  await router.start('listing');
}

void bootstrap().catch((err) => {
  console.error('[wansport] Failed to bootstrap', err);
  const root = document.getElementById('app');
  if (root) {
    root.innerHTML = `
      <div style="padding:40px 24px;text-align:center;font-family:Manrope,sans-serif;">
        <h2 style="font-size:18px;font-weight:800;margin-bottom:12px;color:#111111;">
          Impossibile avviare l'applicazione
        </h2>
        <p style="font-size:13px;color:#475569;">${err instanceof Error ? err.message : 'Errore sconosciuto'}</p>
      </div>
    `;
  }
});
